<script setup lang="ts">
defineProps({
  title: { type: String, required: true },
  description: { type: String, required: true },
  icon: { type: String, required: true },
})

const { element, handleMove, handleOut } = useFloatingCard()
</script>

<template>
  <div
    ref="element"
    @mousemove="handleMove"
    @mouseout="handleOut"
    :class="['xs:p-4 rounded-lg p-2 sm:p-8', 'flex flex-col items-center', 'hover:bordershadow-lg-gray hover:bg-white']"
    :style="{ transition: 'box-shadow 0.1s, transform 0.1s, background 0.1s' }"
  >
    <img :src="icon" aria-disabled role="presentation" class="mb-4 w-12 sm:mb-10 sm:w-16" />

    <Heading class="bg-main-100 bordershadow-main text-main-900 mb-4 w-fit rounded-full px-4 py-1 text-center text-sm">
      {{ title }}
    </Heading>
    <Paragraph class="text-gray- text-center text-[18px]">
      {{ description }}
    </Paragraph>
  </div>
</template>
